import qs from 'qs';
import {escape as lodashEscape, unescape as lodashUnescape} from 'lodash';
import {test as testRegExp} from '@packages/utilities/fp/utils';

export {
  formatNumber,
  formatEmail,
  formatPhone,
} from '@packages/systems/dynamo/utils/DynamoFormattingUtils';
export {
  test,
  castItemValue,
  castConditionValue,
  parseDate,
} from '@packages/systems/dynamo/utils/DynamoConditionUtils';

// This "use strict" is required here, and is NOT safe to remove until we move
// to Node 6, because the backend imports this file via lib/index.js
('use strict');

/**
 * Contains static utilities to deal with Dynamo conditional visibility for DOM nodes.
 */

const DYN_CONTEXT = 'DYN_CONTEXT';

export const matchesDynContextConstant = testRegExp(
  new RegExp('^' + DYN_CONTEXT + '(\\..+)?$')
);

export function applyClasses(
  isConditionOk: boolean,
  trueClassName: string,
  falseClassName: string,
  keepClassNames: string[]
) {
  const allClasses = keepClassNames
    .concat([isConditionOk ? trueClassName : falseClassName])
    .filter((className) => {
      return Boolean(className);
    });

  return allClasses.length > 0 ? allClasses.join(' ') : null;
}

// Format data strings into a template-safe format
export function format(o: any) {
  return lodashEscape(JSON.stringify(o))
    .replace(/%/g, '%%')
    .replace(/&/g, '%26');
}

// Parsed out template-safe data strings into query format
export function parse(s: string) {
  const firstUnescape = s.replace(/%26/g, '&').replace(/%%/g, '%');

  const unescapedStr = lodashUnescape(firstUnescape);
  let result;

  try {
    result = JSON.parse(unescapedStr);
  } catch (e: any) {
    result = _unescapeKeys(_legacyParse(s));
  }

  return result;

  function _legacyParse(str: string) {
    return JSON.parse(JSON.stringify(qs.parse(unescape(str))), function (k, v) {
      if (k !== '__proto__') {
        return v;
      } else {
        return undefined;
      }
    });
  }

  function _unescapeKeys(obj: any) {
    function recurse(o: any) {
      if (typeof o === 'object' && o !== null && !Array.isArray(o)) {
        const out: Record<string, any> = {};

        for (const k in o) {
          const match = k.match(/^_([0-9]+)$/);
          if (match) {
            // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
            out[match[1]] = recurse(o[k]);
          } else {
            out[k] = recurse(o[k]);
          }
        }
        return out;
      } else {
        return o;
      }
    }
    return recurse(obj);
  }
}

export function bindDynContext(conditionData: any, dynContextId: string) {
  conditionData = _clone(conditionData);

  const fields = conditionData.fields;
  const idField = fields._id;
  for (const operatorName in idField) {
    if (idField[operatorName] === DYN_CONTEXT) {
      idField[operatorName] = dynContextId;
    }
  }

  return conditionData;
}

function _clone(o: any) {
  return JSON.parse(JSON.stringify(o));
}
